import React from 'react';
import { textRight, linkText } from 'scy/utils.mod.scss';
import { top_xs, right_sm, tablet_right_0 } from 'scy/padding.mod.scss';

export default function SignupFooter() {
  return (
    <div className={`${top_xs} ${textRight} ${right_sm} ${tablet_right_0}`}>
      <small>
        Don{"'"}t have an account?{' '}
        <a href="/signup" className={linkText}>
          Sign up
        </a>
        .
      </small>
    </div>
  );
}
